import axios from 'axios'

import env from 'env'

import { extractResponseData } from '../utils'

const agentReviewApiInstance = axios.create({
  baseURL: env.AGENT_REVIEW_API_BASE_URL,
})

agentReviewApiInstance.interceptors.response.use(extractResponseData)

export { agentReviewApiInstance }

export default agentReviewApiInstance
